/**
 * Cancels every given subscription by its own id, one request per id.
 * Cancelling stops the next renewal only; tariff periods stay governed by backend tariff data.
 *
 * `cancelOne(id)` must resolve to the mutation result (truthy = cancelled) or throw.
 * Never rejects: each id ends up in exactly one of `succeeded` / `failed`.
 *
 * @param {Array<string|number>} ids
 * @param {(id: string) => Promise<any>} cancelOne
 * @returns {Promise<{ succeeded: string[], failed: Array<{ id: string, error: any }> }>}
 */
export async function cancelSubscriptionsByIds(ids, cancelOne) {
    const uniqueIds = [...new Set((Array.isArray(ids) ? ids : [ids])
        .filter(id => id !== null && id !== undefined && id !== '')
        .map(String))]
    const succeeded = []
    const failed = []

    // Sequential on purpose: predictable order and no parallel load on the payment provider.
    for (const id of uniqueIds) {
        try {
            if (await cancelOne(id)) {
                succeeded.push(id)
            } else {
                failed.push({ id, error: null })
            }
        } catch (error) {
            failed.push({ id, error })
        }
    }

    return { succeeded, failed }
}

export default { cancelSubscriptionsByIds }
